import { ActivatePartnerSalesResponseSchema } from './activate-partner-sales.schema';
/**
 * Activate Partner Sales Endpoint Contract
 * Links a Bliks partner user to a HubSpot contact in the partner company —
 * matching an existing company contact by email, or creating a new one from the
 * user's data — so the user can submit leads. Partner-admin only.
 */ export const activatePartnerSalesContract = {
    method: 'POST',
    path: '/api/v2/partner/members/:userId/activate-sales',
    description: 'Links a partner user to a HubSpot contact so it can submit leads',
    responseSchema: ActivatePartnerSalesResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a partner-admin or no partner company linked',
            404: 'Not Found - no such user in this tenant',
            409: 'Conflict - the user is already linked to a HubSpot contact',
            502: 'Bad Gateway - HubSpot API request failed (e.g. missing write scope)'
        }
    }
};

//# sourceMappingURL=activate-partner-sales.contract.js.map